import '../../../../stylesheets/components/location_marker.scss';

const createLocationMarker = ({ OverlayView = window.google.maps.OverlayView, ...args }) => {
  class LocationMarker extends OverlayView {
    constructor() {
      super();
      const { latitude, longitude } = args.position;

      this.position = new window.google.maps.LatLng(latitude, longitude);
      this.accuracy = args.accuracy;

      this.setMap(args.map);
    }

    // Used to update the position of the marker given an object literal
    // containing latitude and longitude.
    updatePosition(newPosition) {
      if (!this.addedToMap) {
        // Since nothing has been initialized
        return;
      }

      const { latitude, longitude } = newPosition;

      if (latitude && longitude) {
        this.position = new window.google.maps.LatLng(
          latitude,
          longitude,
        );
      }

      this.draw();
    }

    // Inherited from Superclass.
    // Called whenever the map wants to render.
    draw() {
      this._positionRootDiv();
    }

    setVisible(isVisible) {
      this.rootDiv.style.visibility = isVisible ? 'visible' : 'hidden';
    }

    // Inherited from Superclass.
    // Called when marker has been successfully added to map and is ready
    // to be drawn.
    onAdd() {
      this._createRootDiv();
      this._appendDivToOverlay();
      this.addedToMap = true;
    }

    // Inherited from Superclass.
    // Called when the marker has been removed from the map.
    onRemove() {
      if (this.rootDiv) {
        this.rootDiv.parentNode.removeChild(this.rootDiv);
        this.rootDiv = null;
      }
    }

    // Need this to exposition location to InfoWindow etc.
    getPosition() {
      return this.position;
    }

    getDraggable() {
      return false;
    }

    getPositionInContainer() {
      return this.getProjection().fromLatLngToContainerPixel(this.position);
    }

    _positionRootDiv() {
      const point = this.getProjection().fromLatLngToDivPixel(this.position);

      if (point) {
        this.rootDiv.style.left = `${point.x - this.rootDiv.offsetWidth / 2}px`;
        this.rootDiv.style.top = `${point.y - this.rootDiv.offsetHeight / 2}px`;
      }
    }

    _createRootDiv() {
      this.rootDiv = document.createElement('div');
      this.rootDiv.className = 'location-marker_container';

      const radiusElement = document.createElement('div');
      radiusElement.className = 'location-marker_radius';

      const markerElement = document.createElement('div');
      markerElement.className = 'location-marker';

      const innerMarkerElement = document.createElement('div');
      innerMarkerElement.className = 'location-marker_inner';

      markerElement.appendChild(innerMarkerElement);
      this.rootDiv.appendChild(radiusElement);
      this.rootDiv.appendChild(markerElement);

      window.google.maps.event.addDomListener(this.rootDiv, 'click', () => {
        window.google.maps.event.trigger(this, 'click');

        // Stops the triggering of click event on map since this marker has
        // caught it. IMPORTANT to allow user to click outside marker to close
        // it
        window.event.stopPropagation();
      });
    }

    _appendDivToOverlay() {
      const panes = this.getPanes();
      panes.overlayMouseTarget.appendChild(this.rootDiv);
    }
  }

  return new LocationMarker();
};

export default createLocationMarker;
